// extracted by mini-css-extract-plugin
module.exports = {"card":"viewKVMember_card__3lUYD","portfolioCard":"viewKVMember_portfolioCard__h-y1r","portDesc":"viewKVMember_portDesc__3bV7d"};